<!-- CustomTable.vue -->
<template>
  <table class="tx-table">
    <thead>
      <tr>
        <th v-for="column in columns" :key="column.key">
          {{ column.title }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in data" :key="index">
        <td v-for="column in columns" :key="column.key">
          <component
            :is="column.render ? renderCell(column, row, index) : null"
            v-if="column.render"
          />
          <template v-else>
            {{ row[column.key] }}
          </template>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script setup>
const { schools } = inject('GlobalStore');

const props = defineProps({
  columns: {
    type: Array,
    required: true,
  },
  data: {
    type: Array,
    required: true,
  },
});

const renderCell = (column, row, rowIndex) => {
  return h(column.render, {
    row,
    column,
    index: rowIndex,
  });
};
</script>
